<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Change Bulk Learner Division
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" @change="getStd()" outlined
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined persistent-hint
                        hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data && sel_std_data">
                    <v-btn class="mt-6 button" @click="getlearners()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col v-if="learner_list!=''" cols="12" sm="12" md="12">
                <v-col cols="12" sm="6" md="6" class="ml-auto">
                    <v-text-field v-model="search" append-icon="mdi-magnify"
                        label="Search by Student name or by Registration Number" single-line
                        hide-details></v-text-field>
                </v-col>
                <v-simple-table dense class="elevation-1" fixed-header height="500px">
                    <thead>
                        <tr>
                            <th class="">Sr. No.</th>
                            <th class="">Registration No.</th>
                            <th class="">Name</th>
                            <th class="">Admission Year</th>
                            <th class="">Standard</th>
                            <th class="">Old Division</th>
                            <th class="">New Division</th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr v-for="s in filteredItems" :key="s.id">
                            <td>{{s.sr_no}}</td>
                            <td>{{s.reg_no}}</td>
                            <td>{{s.name}}</td>
                            <td>{{s.learner_addmission_year}}</td>
                            <td>{{s.standard}}</td>
                            <td>{{s.old_div}}</td>
                            <td>
                                <v-autocomplete class="pt-3" color="#0F2027" dense rounded required v-model="s.new_div"
                                    :items="div_off_list" item-text="div_name" item-value="div_off_id" label="Division"
                                    outlined persistent-hint hint="Please Select Division" />
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center> <v-btn class="mt-6 button" :loading="save_loader" @click="changeDivision(learner_list)">Change
                        Division</v-btn></center>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data() {
            return {
                fetch_loader: false,
                save_loader: false,
                com_sub_loader: false,
                overlay: false,
                // extraBreadcrumbItems: [
                  

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                selected: [],
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                snackbar_msg: "",
                color: "",
                search: "",
                snackbar: false,
                learner_list:[],
                div_off_list:[],
            };
        },

        methods: {
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        // this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getlearners() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                };
                this.fetch_loader = true;
                axios
                    .post("/admission/getBulkDivOfferingData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.div_off_list = res.data.div_off_list
                            this.learner_list = res.data.learner_list
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            changeDivision(learner_list){
                console.log(learner_list)
                const data = {
                    learner_list : learner_list
                }
                 this.save_loader = true;
                axios
                    .post("/admission/saveBulkDivOfferingData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.save_loader = false;
                            this.showSnackbar("#4CAF50", "Division Changed Successfully..");
                            this.getlearners()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.getlearners()
                            this.save_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.save_loader = false;
                    })
                    .finally(() => {
                        this.save_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
        computed: {
            filteredItems() {
                return this.learner_list.filter((s) => {
                    return s.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || s.reg_no.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                });
            },
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
</style>
        right: 0;
    }
</style>
